import type { IncidentStatus } from '../../../../../shared/constants/incident-status-icons.constants';

/** Maps variance UI status dropdown values to API / DB enum (snake_case). */
const UI_TO_API: Record<IncidentStatus, string> = {
  Archived: 'closed',
  'Investigation Resolved': 'resolved',
  New: 'new',
  Open: 'open',
  'Pending Response': 'pending_response',
  'Practice Issue': 'escalated_to_mgmt',
  'Reviewed - Accounted': 'reviewed',
  'Reviewed - Unaccounted': 'reviewed',
  'Under Review': 'under_investigation',
  Unresolved: 'unresolved',
};

const API_TO_UI: Record<string, IncidentStatus> = {
  new: 'New',
  open: 'Open',
  pending_response: 'Pending Response',
  reviewed: 'Reviewed - Unaccounted',
  under_investigation: 'Under Review',
  resolved: 'Investigation Resolved',
  unresolved: 'Unresolved',
  closed: 'Archived',
  escalated_to_mgmt: 'Practice Issue',
};

const API_SNAKE_TO_LABEL: Record<string, string> = {
  new: 'New',
  open: 'Open',
  pending_response: 'Pending Response',
  reviewed: 'Reviewed',
  under_investigation: 'Under Review',
  resolved: 'Investigation Resolved',
  unresolved: 'Unresolved',
  closed: 'Closed',
  escalated_to_mgmt: 'Escalated to Management',
};

export function uiIncidentStatusToApiValue(status: IncidentStatus): string {
  return UI_TO_API[status] ?? 'open';
}

export function apiIncidentStatusToUi(snake: string): IncidentStatus {
  return API_TO_UI[snake] ?? 'Open';
}

export function apiStatusSnakeToLabel(snake: string | null | undefined): string {
  if (snake == null || snake === '') return '—';
  return API_SNAKE_TO_LABEL[snake] ?? snake.replaceAll('_', ' ');
}
